// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellModal-cls1_2DC","cls2":"TasteOfMentionsUpsellModal-cls2_MXY TasteOfMentionsUpsellModal-cls1_2DC"};